import { ISettingsService } from "../../typings/typings";
import { IApiGameAccount } from "ng-league";

export interface BnetOauthEvent {
    type: string;
    newGameAccountValue?: string;
    errorMessage?: string;
    timestamp: Date;
}

export class UpdateBnetOauthContainer {
    public gameAccountType: string;
    public gameAccountName: string;
    public currentGameAccount: string;
    public onSuccess: (value: { newGameAccount: IApiGameAccount }) => void;

    public errorMessage: string | undefined;

    public static $inject = ["SettingsService"];
    constructor(private SettingsService: ISettingsService) {}

    public $onInit() {
        window.addEventListener("storage", this.receiveMessage.bind(this));
    }

    public $onDestroy() {
        window.removeEventListener("storage", this.receiveMessage.bind(this));
    }

    /**
     * Receive local storage events and react on known messages.
     * @param event
     */
    private receiveMessage(event: StorageEvent) {
        const userId = this.SettingsService.user && this.SettingsService.user.id;
        const gameAccountType = this.gameAccountType;
        const key = event.key;

        if (key !== `bnet-oauth-message-${userId}-${gameAccountType}` && key !== `bnet-oauth-message-${userId}`) {
            return;
        }

        if (!userId) {
            return;
        }
        if (!event.newValue) {
            return;
        }

        const eventObj = JSON.parse(event.newValue) as BnetOauthEvent;

        switch (eventObj.type) {
            case "success":
                this.onSuccess({
                    newGameAccount: {
                        type: this.gameAccountType,
                        value: eventObj.newGameAccountValue,
                    },
                });
                break;
            case "error":
                this.errorMessage = eventObj.errorMessage ? eventObj.errorMessage : "unkown-error";
                break;
        }
    }
}
